<template>

  <div class="dropdown">
    <ElButton type="dropdown" ref="codeBtnRef" @blur="blurEvent()">{{ state.selectCode ?.cd_nm ? state.selectCode.cd_nm : '-' }}</ElButton>
    <ul class="dropdown-menu" v-show="props.isShow" ref="dropDownRef">
      <li v-for="(item, index) of state.codeList" :key="index">
        <a class="dropdown-item" @click="changeVal(item)">
          {{ item.cd_nm }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { onBeforeMount, reactive, ref, onMounted,computed,watch,watchEffect} from "vue";
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()

const codeBtnRef = ref();
const dropDownRef = ref()
const emits = defineEmits(["return",]);

const props = defineProps({
  cd_gr: String,
  chk_ess: String,
  matchCd: String,
  matchNm: String,
  isShow : {
    type : Boolean,
    default : true
  },
  focus:{
    type : Boolean,
    default: false
  },
  hyphenIS :{
    type: Boolean,
    default : false
  }
});

const state = reactive({
  cd_gr: "",
  chk_ess: "",
  codeList: [],
  selectCode: {
    cd_id: "",
    cd_nm: "",
  },
});

const matchCd = computed(()=>props.matchCd)


watch(matchCd,(newVal,oldVal)=>{
  // getCodeDtl()
  if(state.codeList.length > 1){
    state.codeList.forEach((item)=>{
      if(item.cd_id == matchCd.value){
        state.selectCode = item
      }
    })
  }
  
})

onBeforeMount(async () => {
  // chk_ess : props에 chk_ess 필수값 체크변수를 넣어서 'Y'이면 Null값이 들어가면 안되기 때문에 cd_nm값에 '-'를 넣지 않도록 했다.
  if(props.chk_ess === 'Y') {
    // state.codeList = [{cd_id : '', cd_nm : ''}]
  } else {
    state.codeList = [{cd_id : '', cd_nm : '-'}]
  }

  await getCodeDtl()
});

onMounted(async () => {
  if(props.focus){
    codeBtnRef.value.button.focus();
  }
});

const getCodeDtl = async ()=>{
  try{
    if (!codeStore.codeDtlList) {
      await codeStore.getCodeDtlList()
    }
    let codeDtlLsit = codeStore.codeDtlList

    if (props.cd_gr != "" && props.cd_gr != undefined && props.cd_gr != null) {
      try {
        state.cd_gr = props.cd_gr;
        //인자값으로 받은 코드그룹 추출
        codeDtlLsit.forEach((i)=>{
          if(i.cd_gr == props.cd_gr){
            state.codeList.push(i)
          }
        });

        if (matchCd.value != "" && matchCd.value != undefined && matchCd.value != null) {
          for (let item of state.codeList) {
            if (item["cd_id"] == matchCd.value) {
              state.selectCode = item;
            }
          }
        }

        // await nextTick()

        if(state.selectCode.cd_id == '' || state.selectCode.cd_id == undefined || state.selectCode.cd_id == undefined){
          state.selectCode = state.codeList[0]
        }
        // emits('return',state.selectCode)
      } catch (error) {
        // alert('공통코드 erro')
        console.log("select 공통코드 error", error);
      }
    }
  }catch(error){
    console.log(error)
  }
}

const changeVal = (item) => {
  if(item){
    state.selectCode = item;
  }
  emits("return", state.selectCode);
};

const nullDefault = () =>{
    state.selectCode = '';
}

const focus = () => {
  codeBtnRef.value.button.focus();
};

const blurEvent = () =>{
  if(dropDownRef.value?.className === 'dropdown-menu'){
    emits("return", state.selectCode);
  }
}


defineExpose({
  focus,
  nullDefault,
});
</script>
